import { getAvailableProductQuantity } from './getAvailableProductQuantity';

export const isSoldOut = (product) => {
  if (!product) {
    return false;
  }

  const availableProductQuantity = getAvailableProductQuantity(product);
  return availableProductQuantity === 0;
};
